"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var keyValuePattern = /[^?&=]+=[^?&=]*/;
function stringify(obj) {
    if (typeof obj !== 'object') {
        return obj;
    }
    var str = [];
    Object.keys(obj || {}).forEach(function (p) {
        if (obj[p] !== '' && obj[p] !== undefined) {
            var key = encodeURIComponent(p);
            var value = encodeURIComponent(stringify(obj[p]));
            str.push(key + "=" + value);
        }
    });
    return str.join('&');
}
exports.stringify = stringify;
function parse(input) {
    var str = input;
    if (['?', '#'].indexOf(str.substr(0, 1)) !== -1) {
        str = str.substr(1);
    }
    return str.split('&').reduce(function (obj, set) {
        var _a = set.split('=').map(decodeURIComponent), key = _a[0], value = _a[1];
        var parsed;
        if (keyValuePattern.test(value)) {
            parsed = parse(value);
        }
        else {
            parsed = value;
        }
        obj[key] = parsed;
        return obj;
    }, {});
}
exports.parse = parse;
//# sourceMappingURL=serialize.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/auth-client/lib/serialize.js
// module id = 733
// module chunks = 0